'use client'

import { useEffectOnce } from 'react-use'

import { destinations } from '@/constants/menu'
import { useCommonStore } from '@/libs/stores/common.store'

/**
 * Feeds the navbar's destination menu from the branch list the layout already SSR'd.
 *
 * Lives here rather than in `bootstrap.tsx` because that one renders inside `AppProvider` in the
 * ROOT layout — above `DestinationProvider` — so it had no way to reach this data and refetched
 * `/api-v2/branches` on every session instead.
 */
export function DestinationsSync({ branches }: { branches: IBranch[] }) {
  const setDestinations = useCommonStore((action) => action.setDestinations)

  useEffectOnce(() => {
    if (!branches?.length) return

    const results = destinations.map((record, index) => {
      const city = branches[index]

      return {
        ...record,
        children: (city?.branches ?? []).map((branch) => ({
          href: `${branch.url}`,
          label: branch.name,
          description: branch.medium_desc
        }))
      }
    })

    setDestinations(results)
  })

  return null
}
